import type React from 'react';
import { useIntl } from 'react-intl';

import Button from 'src/app/ui/components/atoms/button';
import ProfileDetails from 'src/app/ui/components/molecules/profile-details';

import type { ProfilePageQuery } from 'src/app/types/graphql';
import { ViewPageButtonWrapper } from 'src/app/ui/components/molecules/profile-button-wrapper';
import { signout } from 'src/actions/auth';
import { useDispatch } from 'src/state';

interface renderViewProfileArgs {
  handleEditButtonClick: () => void;
  userDetails: ProfilePageQuery['userById'];
}

const ViewProfile: React.FC<renderViewProfileArgs> = ({ handleEditButtonClick, userDetails }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const editProfileLabel = intl.formatMessage({ id: 'profile.buttons.edit' });
  const signOutLabel = intl.formatMessage({ id: 'profile.buttons.signOut' });

  return (
    <>
      <ProfileDetails userDetails={userDetails} />
      <ViewPageButtonWrapper>
        <Button label={editProfileLabel} type="secondary-white" onClick={handleEditButtonClick} />
        <Button
          label={signOutLabel}
          type="secondary-white"
          onClick={() => {
            dispatch(signout({ triggeredBy: 'user' }));
          }}
        />
      </ViewPageButtonWrapper>
    </>
  );
};

export default ViewProfile;
